const LANGUAGE = {
  VI: ['vi', 'VI'],
  EN: ['en', 'EN'],
};

export default LANGUAGE;
